











import { Component, Mixins } from "vue-property-decorator";
import { ModelEditableMixin } from "../../../../system/mixins";
import { DocumentPageNavigatableMixin } from "../../mixins";

@Component
export default class Pagenation extends Mixins(ModelEditableMixin, DocumentPageNavigatableMixin) {
  get isDocumentAlreadyInitialized(): boolean {
    return this.isSourceEnable
      && this.editingSource.isAlreadyInitialized;
  }
}
